import { ErrorCodes, ErrorNames } from 'types/error';

export const CUSTOM_ERROR_CODES: { [key in ErrorCodes]: ErrorNames } = {
  40095000: 'SERVICE_DISABLED_WITH_TOGGLE_BASED',
  40095001: 'SERVICE_DISABLED_WITH_TIME_BASED',
};
